// Function to get current url
export const getCurrURL = () => {
  const urlString = window.location.href;
  const url = new URL(urlString);

  return url.href;
};
